import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'Setup',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.pageTitle + ' | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      processing: false,
      verified: false
    }
  },
  beforeMount () {
    if (this.authorized)
      this.$router.push({name: 'Home'})
  },
  mounted () {
    this.$nextTick(this.init)
    // this.init()
  },
  computed: {
    ...mapState({
      authorized: state => state.auth.authorized
    }),
    ...mapGetters({
      getMeta: 'meta/get'
    }),

    siteName() {
      return Constants.SiteInfo.name
    },
    pageTitle () {
      return 'セットアップ'
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      setSigninFlag: 'signin/setFlag'
    }),
    init () {
      this.processing = true

      // メールアドレス受信確認トークンを取得
      let token
      try {
        token = location.search.split('?').join('').split('token=')[1]
      /* eslint-disable no-new */
      } catch (e) {
        return
      }

      let parameters = {
        request: {
          activationToken: token
        }
      }
      console.log('parameters : ', parameters)

      // ユーザのメールアドレスをアクティベート
      ApiManager.request(
        ['auth'],
        ['v1UserActivatePost'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            this.verified = true

            // 認証の初期セットアップフラグをtrueにする
            const flag = res[0].data.passwordChanged === undefined
              ? true
              : !res[0].data.passwordChanged
            this.setSigninFlag(flag)

            // 5秒後にログイン画面へリダイレクト
            setTimeout(() => {
              this.$router.push({
                name: 'Signin'
              })
            }, 5000)

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    }
  }
}